// Course/CoursesPage.tsx

import React, {useContext, useEffect, useState} from 'react';
import {useErrorProcessing} from 'Core/components/ErrorProvider';
import {axios, DOMAIN_URL} from 'Auth/axiosConfig';
import CircularProgress from 'Core/components/elements/CircularProgress';

import {ICourse} from '../../Types/psychology/course';
import {FRCT} from 'WideLayout/Layouts';
import {AuthContext, AuthContextType} from 'Auth/AuthContext';
import pprint from '../../Utils/pprint';
import CourseCard from "Course/CourseCard";
import Head from "Core/components/Head";

interface CoursesPageProps {
    cls?: string;
}

const CoursesPage: React.FC<CoursesPageProps> = (
    {
        cls,
    }) => {
    const [coursePacks, setCourses] = useState<ICourse[]>([]);
    const [userCourses, setUserCourses] = useState<ICourse[]>([]);
    const {byResponse} = useErrorProcessing();
    const {isAuthenticated} = useContext(AuthContext) as AuthContextType;

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const response = await axios.get('/api/v1/courses/');
                pprint('Course packs')
                pprint(response.data);
                setCourses(response.data);
            } catch (error) {
                byResponse(error);
            }
        };
        const fetchUserCourses = async () => {
            try {
                const response = await axios.get('/api/v1/user/courses/');
                pprint('User Course packs')
                pprint(response.data);
                setUserCourses(response.data);
            } catch (error) {
                byResponse(error);
            }
        };
        fetchCourses();
        if (isAuthenticated) fetchUserCourses();

    }, [isAuthenticated]);

    if (!coursePacks.length) return <CircularProgress size={'150px'}/>;

    const userCourseIds = new Set(userCourses.map((course) => course.id));
    const filteredCourses = coursePacks.filter((course) => !userCourseIds.has(course.id));
    const publicCourses = filteredCourses.filter((course) => course.is_public);
    const privateCourses = filteredCourses.filter((course) => !course.is_public);
    const allCourses = [...userCourses, ...publicCourses, ...privateCourses];

    return (
        <>
            <Head
                title={'Курсы | Лайф Хелп'}
                description={'Помощь квалифицированных психологов от сервиса Лайф Хелп'}
                robots={'noindex, nofollow'}
                canonicalUrl={`${DOMAIN_URL}/courses`}
            />
            <FRCT cls={cls} maxW={800} p={2}
                  wrap g={2} scroll={'y-auto'}>
                {allCourses.map((course, i) => (
                    <CourseCard key={i} course={course}/>
                ))}
            </FRCT></>
    );
};

export default CoursesPage;
